const Cart = {
    getItems: () => {
        return axios.get(route('client.cart.items'))
            .then(resp => {
                if (resp.data.success) {
                    window.cartData = resp.data.cartData
                    window.dispatchEvent(new Event('cartUpdated'))
                }
                return resp
            })
    },
    add: (data) => {
        return axios.post(route('client.cart.add'), {...data})
            .then(resp => {
                if (resp.data.success) {
                    window.cartData = resp.data.cartData
                    Cart.notify({...data})
                }
                return resp
            })
    },
    update: (data) => {
        const cartData = window.cartData.products.find(i => +i.id === +data.id)
        return axios.post(route('client.cart.update'), data)
            .then(resp => {
                if (resp.data.success) {
                    window.cartData = resp.data.cartData
                    Cart.notify({...cartData}, data.quantity > 0 ? 'cartAdd' : 'cartDelete')
                }
                return resp
            })
    },
    remove: (data) => {
        return axios.post(route('client.cart.remove'), data)
            .then(resp => {
                if (resp.data.success) {
                    window.cartData = resp.data.cartData
                    Cart.notify({}, 'cartDelete')
                }
                return resp
            })
    },
    clear: () => {
        return axios.post(route('client.cart.clear'))
            .then(resp => {
                if (resp.data.success) {
                    window.cartData = resp.data.cartData
                    Cart.notify({}, 'cartDelete')
                }
                return resp
            })
    },
    notify:(data, type = 'cartAdd') => {
        window.dispatchEvent(new Event('cartUpdated'))

        /*window.dispatchEvent(new CustomEvent(type, {
            detail: {variant_id: variant_id}
        }))*/
    },
    callback: (e) => {
        const prodId = e.target.dataset.prodAddModalId;
        const variantId = e.target.dataset.prodAddModalVariantId;
        const available = e.target.dataset.prodAvailable;
        if (available == 0) {
            window.prodModal.showModal(prodId, variantId, 0)
        } else if (variantId) {
            Cart.add(variantId)
        } else if (prodId) {
            window.prodModal.showModal(prodId, variantId)
        }
    }
}
export default Cart
